import type { guide as guideEn } from "../../en/webHints/guide";

// Nápovědy polí editoru průvodce (řez 10). Klíče volá registr nápověd
// (`apps/admin/src/lib/webHints/guide.ts`). Text „web“ jmenuje „<stránka> → <sekce>“ bez
// předpony „Na webu:“; text „backoffice“ navazuje na „Nezobrazuje se na webu, slouží pro“.
export const guide: typeof guideEn = {
  name: "Stránka průvodce → nadpis H1; dále karta na stránce Průvodci, pás průvodců na stránce země a blok průvodce na stránce zájezdu",
  slug: "Adresa stránky → /pruvodce/<adresa>",
  yearsExperience: "Stránka průvodce, karta průvodce a blok na stránce zájezdu → roky zkušeností",
  livingIn: "Stránka průvodce, karta průvodce a blok na stránce zájezdu → bydliště",
  bio: "Stránka průvodce → medailonek; dále blok průvodce na stránce zájezdu",
  specializations: "Stránka průvodce a karta průvodce → štítky specializací",
  photoMediaId:
    "Stránka průvodce, karta průvodce, pás průvodců na stránce země a blok na stránce zájezdu → fotka",
  countryIds:
    "Stránka průvodce → země v záhlaví; dále karta na stránce Průvodci a pás průvodců na stránce země. První země je domovská destinace v harmonogramu průvodců",
  interview:
    "Stránka průvodce → sekce „Ptali jsme se“ (otázky v tomto pořadí; bez otázek se sekce nezobrazí)",
  tips: "Stránka průvodce → tipy (jen vyplněná pole; bez tipů se sekce nezobrazí)",
  galleryImageIds: "Stránka průvodce → galerie (prvních 24 fotek v tomto pořadí)",
  homeDestinationId: "seskupení průvodce pod tým destinace v harmonogramu průvodců",
  sortOrder: "pořadí průvodců v harmonogramu průvodců (stránka Průvodci je řadí abecedně)",
  isActive:
    "Celý web → stránka průvodce, karta na stránce Průvodci, pás průvodců na stránce země, odkaz na profil u karet specialistů a odkaz „Naši průvodci“ v menu (neaktivní je skrytý)",
};
